export enum NotificationsPermissionsE {
  Granted = 'granted',
  Denied = 'denied',
  Default = 'default',
}

export enum NotificationActionsE {
  TicketCreated = 'TicketCreated',
  TicketClosed = 'TicketClosed',
  TicketReOpened = 'TicketReOpened',
  TicketApproved = 'TicketApproved',
  TicketApprovalRequested = 'TicketApprovalRequested',
  TicketMessageSent = 'TicketMessageSent',
  TicketAttachmentUploaded = 'TicketAttachmentUploaded',
  MessageBoardUpdated = 'MessageBoardUpdated',
}
